import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {ShoppingCartService} from '@app/service/shopping-cart.service';
import {EMPTY, map, Observable, Subject, takeUntil} from 'rxjs';
import {animate, keyframes, state, style, transition, trigger} from '@angular/animations';
import {whenElapsed} from '@app/shared/util/promise-util';

const highlightAnimationMs = 1250;

@Component({
	selector: 'app-shopping-cart-toggle',
	templateUrl: './shopping-cart-toggle.component.html',
	animations: [
		trigger('highlighted', [
			state('false', style({'box-shadow': '0px 6px 6px -3px rgb(0 0 0 / 20%), 0px 10px 14px 1px rgb(0 0 0 / 14%), 0px 4px 18px 3px rgb(0 0 0 / 12%)'})),
			state('true', style({})),
			transition('* => true', [
				animate(`${highlightAnimationMs}ms cubic-bezier(0.66, 0.33, 0, 1)`, keyframes([
					style({'box-shadow': '0 0 0 0 #f0f0f0, 0 0 0 0 #0b213d'}),
					style({'box-shadow': '0 0 0 12px transparent, 0 0 0 24px transparent'})
				]))
			])
		])
	]
})
export class ShoppingCartToggleComponent implements OnInit, OnDestroy {
	@Input() highlight$: Observable<void> = EMPTY;
	@Output() openShoppingCart = new EventEmitter<void>();

	numberOfItems$: Observable<number>;
	isHighlighted: boolean = false;
	#destroyed$ = new Subject<void>();

	constructor(private shoppingCartService: ShoppingCartService) {
		this.numberOfItems$ = shoppingCartService.articleList$.pipe(
			map(items => items.reduce(
				(accumulator, item) => accumulator + item.quantity.value, 0)
			)
		);
	}

	ngOnDestroy(): void {
		this.#destroyed$.next();
		this.#destroyed$.complete();
	}

	ngOnInit(): void {
		this.highlight$.pipe(takeUntil(this.#destroyed$)).subscribe(async () => {
			await this.animateHighlight();
			await this.animateHighlight();
		});
	}

	private async animateHighlight(): Promise<void> {
		this.isHighlighted = true;
		await whenElapsed(highlightAnimationMs);
		this.isHighlighted = false;
		await whenElapsed(0);
	}
}
